<template>
  <section id="view-emr-order" v-loading="loading">
    <div class="tabs-content">
      <div class="container-default">
        <div class="case-creation">
          <div class="case-creation__step case-creation__patient-information">
            <div class="phlebio-status-navbar">
              <el-row type="flex" align="middle">
                <el-col :span="18">
                  <ul class="emr-result">
                    <li
                      v-if="
                        this.getSinglePhlebioDetails &&
                        this.getSinglePhlebioDetails.accession_data &&
                        this.getSinglePhlebioDetails.accession_data.length
                      "
                    >
                      <div>
                        <span class="name">Accession Id</span>
                        <span
                          v-for="(
                            item, index
                          ) of getSinglePhlebioDetails.accession_data"
                          :key="index"
                          class="value cursor"
                          @click="goToCaseView(item.case_id)"
                          >{{ item.accession_id }}</span
                        >
                      </div>
                    </li>
                    <li
                      v-else-if="
                        this.getSinglePhlebioDetails &&
                        this.getSinglePhlebioDetails.accession_id
                      "
                    >
                      <div>
                        <span class="name">Accession Id</span>
                        <span
                          class="value cursor"
                          @click="goToCaseView(getSinglePhlebioDetails.case_id)"
                          >{{ getSinglePhlebioDetails.accession_id }}</span
                        >
                      </div>
                    </li>
                    <li
                      v-if="
                        getSinglePhlebioDetails &&
                        getSinglePhlebioDetails.created_at
                      "
                    >
                      <span class="name">Order Created On</span>
                      <span class="value"
                        >{{
                          momentWithTimezone(
                            this.getSinglePhlebioDetails.created_at,
                            "MM-DD-yyyy"
                          )
                        }}
                        {{
                          momentWithTimezone(
                            this.getSinglePhlebioDetails.created_at,
                            "hh:mm a"
                          )
                        }}
                      </span>
                    </li>
                    <li
                      v-if="
                        getSinglePhlebioDetails &&
                        getSinglePhlebioDetails.Order_Type
                      "
                    >
                      <span class="name">Order Type</span>
                      <span class="value">
                        {{
                            getSinglePhlebioDetails.Order_Type 
                        }}
                      </span>
                    </li>
                    <li
                      v-if="
                        getSinglePhlebioDetails &&
                        getSinglePhlebioDetails.Priority
                      "
                    >
                      <span class="name">Priority</span>
                      <span class="value" :style="getSinglePhlebioDetails.Priority === 'STAT' ? 'color: red; font-weight: 600;' : ''">
                        {{
                            getSinglePhlebioDetails.Priority 
                        }}
                      </span>
                    </li>
                  </ul>
                </el-col>
                <el-col :span="6">
                  <ul class="emr-order-status">
                    <li
                      v-if="
                        this.getSinglePhlebioDetails &&
                        this.getSinglePhlebioDetails.Status
                      "
                    >
                      <span class="name">Order Status</span>

                      <span class="value">{{
                        this.getSinglePhlebioDetails.Status
                      }}</span>
                    </li>
                  </ul>
                </el-col>
              </el-row>
            </div>
            <div class="case-creation__card">
              <div v-if="canShowEditButton && !checkEMROrNot">
                <el-button
                  class="edit-btn"
                  v-if="hasPermission('emr_orders', 'edit')"
                  :title="editButtonTitle"
                  @click="caseFormView"
                  :disabled="accessionDisableCreated"
                >
                  <span class="edit-icon">
                    <img
                      src="@/assets/images/icons/edit-case-information.svg"
                      alt=""
                    />

                    EDIT
                  </span>
                </el-button>
              </div>
              <div class="case-view-information" v-if="getPatientInformation">
                <div class="case-creation__heading">
                  <div class="title-with-icon">
                    <span class="icon">
                      <img
                        src="@/assets/images/icons/icon-patient-info.svg"
                        alt="icon"
                        class="img-fluid"
                      />
                    </span>
                    <h3 class="title">Patient Information</h3>
                  </div>
                </div>
                <div class="case-creation__body pb-0 mb-15">
                  <el-row>
                    <el-col :xl="3" :lg="3" :md="8" :sm="12" :xs="12">
                      <div class="input-value">
                        <h4 class="name">First Name</h4>
                        <p class="value">
                          {{
                            getPatientInformation.patient_info
                              ? getPatientInformation.patient_info.first_name
                              : "--"
                          }}
                        </p>
                      </div>
                    </el-col>

                    <el-col :xl="3" :lg="3" :md="8" :sm="12" :xs="12">
                      <div class="input-value">
                        <h4 class="name">Last Name</h4>
                        <p class="value">
                          {{
                            getPatientInformation.patient_info
                              ? getPatientInformation.patient_info.last_name
                              : "--"
                          }}
                        </p>
                      </div>
                    </el-col>
                    <el-col :xl="3" :lg="3" :md="8" :sm="12" :xs="12">
                      <div class="input-value">
                        <h4 class="name">Gender</h4>
                        <p class="value">
                          {{
                            getPatientInformation.patient_info
                              ? getPatientInformation.patient_info.gender
                              : "--"
                          }}
                        </p>
                      </div>
                    </el-col>
                    <el-col :xl="3" :lg="3" :md="8" :sm="12" :xs="12">
                      <div class="input-value">
                        <h4 class="name">Date of Birth</h4>
                        <p class="value">
                          {{
                            getPatientInformation.patient_info
                              ? formatDate(
                                  getPatientInformation.patient_info
                                    .date_of_birth
                                )
                              : "--"
                          }}
                        </p>
                      </div>
                    </el-col>
                    <el-col :xl="3" :lg="3" :md="8" :sm="12" :xs="12">
                      <div class="input-value">
                        <h4 class="name">EMR #</h4>
                        <p class="value">
                          {{
                            getPatientInformation.Emr_order_id ? getPatientInformation.Emr_order_id : "--" || 
                            getPatientInformation.patient_info
                              ? getPatientInformation.patient_info.emr
                              : "--"
                          }}
                        </p>
                      </div>
                    </el-col>

                    <el-col :xl="3" :lg="3" :md="8" :sm="12" :xs="12">
                      <div class="input-value">
                        <h4 class="name">Mobile Number</h4>
                        <p class="value">
                          {{
                            getPatientInformation.patient_info
                              ? getPatientInformation.patient_info.home_phone
                              : "--"
                          }}
                        </p>
                      </div>
                    </el-col>
                    <el-col :xl="3" :lg="3" :md="8" :sm="12" :xs="12">
                      <div class="input-value">
                        <h4 class="name">Phone Number</h4>
                        <p class="value">
                          {{
                            getPatientInformation.patient_info
                              ? getPatientInformation.patient_info.work_phone
                              : "--"
                          }}
                        </p>
                      </div>
                    </el-col>
                    <el-col :xl="3" :lg="3" :md="8" :sm="12" :xs="12">
                      <div class="input-value">
                        <h4 class="name">Email</h4>
                        <p class="value">
                          {{
                            getPatientInformation.patient_info
                              ? getPatientInformation.patient_info.email
                              : "--"
                          }}
                        </p>
                      </div>
                    </el-col>
                    <el-col :xl="3" :lg="3" :md="8" :sm="12" :xs="12">
                      <div class="input-value">
                        <h4 class="name">Address Line 1</h4>
                        <p class="value">
                          {{
                            getPatientInformation.patient_info
                              ? getPatientInformation.patient_info
                                  .address_line_1
                              : "--"
                          }}
                        </p>
                      </div>
                    </el-col>
                    <el-col :xl="3" :lg="3" :md="8" :sm="12" :xs="12">
                      <div class="input-value">
                        <h4 class="name">Address Line 2</h4>
                        <p class="value">
                          {{
                            getPatientInformation.patient_info
                              ? getPatientInformation.patient_info
                                  .address_line_2
                              : "--"
                          }}
                        </p>
                      </div>
                    </el-col>
                    <el-col :xl="3" :lg="3" :md="8" :sm="12" :xs="12">
                      <div class="input-value">
                        <h4 class="name">Zip</h4>
                        <p class="value">
                          {{
                            getPatientInformation.patient_info
                              ? getPatientInformation.patient_info.zip
                              : "--"
                          }}
                        </p>
                      </div>
                    </el-col>

                    <el-col :xl="3" :lg="3" :md="8" :sm="12" :xs="12">
                      <div class="input-value">
                        <h4 class="name">State</h4>
                        <p class="value">
                          {{
                            getPatientInformation.patient_info
                              ? getPatientInformation.patient_info.state
                              : "--"
                          }}
                        </p>
                      </div>
                    </el-col>
                    <el-col :xl="3" :lg="3" :md="8" :sm="12" :xs="12">
                      <div class="input-value">
                        <h4 class="name">City</h4>
                        <p class="value">
                          {{
                            getPatientInformation.patient_info
                              ? getPatientInformation.patient_info.city
                              : "--"
                          }}
                        </p>
                      </div>
                    </el-col>
                    <el-col
                      :xl="3"
                      :lg="3"
                      :md="8"
                      :sm="12"
                      :xs="12"
                      v-if="
                        getPatientInformation.patient_info &&
                        getPatientInformation.patient_info.pregnant
                      "
                    >
                      <div class="input-value view-cases">
                        <h4 class="name">Pregnancy</h4>
                        <p class="value">
                          {{
                            getPatientInformation.patient_info.pregnant
                              ? "Yes"
                              : "No"
                          }}
                        </p>
                      </div>
                    </el-col>
                  </el-row>
                </div>
                <div class="case-creation__heading">
                  <div class="title-with-icon">
                    <span class="icon">
                      <img
                        src="@/assets/images/icons/icon-case-info.svg"
                        alt="icon"
                        class="img-fluid"
                      />
                    </span>
                    <h3 class="title">Case Information</h3>
                  </div>
                </div>
                <div class="case-creation__body pb-0">
                  <el-row gutter="30">
                    <el-col :xl="3" :lg="4" :md="12" :sm="12" :xs="12">
                      <div class="input-value view-cases">
                        <h4 class="value">Case Type</h4>
                        <ul
                          v-for="(
                            caseType, index
                          ) of getPatientInformation.case_types"
                          :key="index"
                        >
                          <li>{{ caseTypeMap[caseType] }}</li>
                        </ul>
                      </div>
                    </el-col>
                    <el-col :xl="3" :lg="4" :md="12" :sm="12" :xs="12">
                      <div class="input-value">
                        <h4 class="name">Laboratory</h4>
                        <p class="value">
                          {{
                            getSinglePhlebioDetails.lab
                              ? getSinglePhlebioDetails.lab.name
                              : "--"
                          }}
                        </p>
                      </div>
                    </el-col>
                    <el-col :xl="3" :lg="4" :md="12" :sm="12" :xs="12">
                      <div class="input-value">
                        <h4 class="name">Ordering Facility</h4>
                        <p class="value" v-if="getSinglePhlebioDetails">
                          {{
                            getPatientInformation.hospital &&
                            getPatientInformation.hospital.name
                              ? getPatientInformation.hospital.name
                              : ""
                          }}
                        </p>
                      </div>
                    </el-col>

                    <el-col :xl="3" :lg="4" :md="12" :sm="12" :xs="12">
                      <div class="input-value">
                        <h4 class="name">Ordering Facility Branch</h4>
                        <p class="value" v-if="getPatientInformation">
                          {{
                            getPatientInformation.hospital_branch
                              ? getPatientInformation.hospital_branch
                                  .display_name
                              : "--"
                          }}
                        </p>
                      </div>
                    </el-col>
                    <el-col :xl="3" :lg="4" :md="12" :sm="12" :xs="12">
                      <div class="input-value">
                        <h4 class="name">Ordering Physician</h4>
                        <p class="value" v-if="getPatientInformation">
                          {{
                            getPatientInformation.ordering_physician &&
                            getPatientInformation.ordering_physician.name
                              ? getPatientInformation.ordering_physician.name
                              : "--"
                          }}
                        </p>
                      </div>
                    </el-col>

                    <el-col :xl="3" :lg="4" :md="8" :sm="8" :xs="8">
                      <div class="input-value">
                        <h4 class="name">Bill To</h4>
                        <p class="value">
                          {{ getSinglePhlebioDetails.billing_type }}
                        </p>
                      </div>
                    </el-col>

                    <el-col :xl="3" :lg="4" :md="12" :sm="12" :xs="12">
                      <div
                        class="input-value view-cases"
                        v-if="getSinglePhlebioDetails"
                      >
                        <h4 class="name">Collection Date</h4>
                        <p class="value">
                          {{
                            getSinglePhlebioDetails.collection_date
                              ? momentWithTimezoneTime(
                                  getSinglePhlebioDetails.collection_date,
                                  "MM-DD-yyyy hh:mm A"
                                )
                              : "--"
                          }}
                        </p>
                      </div>
                    </el-col>
                    <el-col :xl="3" :lg="4" :md="12" :sm="12" :xs="12">
                      <div
                        class="input-value view-cases"
                        v-if="getSinglePhlebioDetails"
                      >
                        <h4 class="name">Received Date</h4>
                        <p class="value">
                          {{
                            getSinglePhlebioDetails.received_date
                              ? momentWithTimezoneTime(
                                  getSinglePhlebioDetails.received_date,
                                  "MM-DD-yyyy hh:mm A"
                                )
                              : "--"
                          }}
                        </p>
                      </div>
                    </el-col>
                    <el-col :xl="10" :lg="10" :md="12" :sm="12" :xs="12">
                      <div class="input-value">
                        <h4 class="name">ICD-10 ( Indicative )</h4>
                        <p
                          v-if="getSinglePhlebioDetails"
                          class="icd-code value"
                          v-html="
                            getSinglePhlebioDetails.icd_10_codes &&
                            getSinglePhlebioDetails.icd_10_codes.length > 0
                              ? printICDCode(
                                  getSinglePhlebioDetails.icd_10_codes
                                )
                              : '--'
                          "
                        ></p>
                      </div>
                    </el-col>
                    <el-col :xl="3" :lg="4" :md="12" :sm="12" :xs="12">
                      <div class="input-value view-cases">
                        <div
                          class="speciment-type-view"
                          v-if="
                            getSinglePhlebioDetails &&
                            getSinglePhlebioDetails.sample_types
                          "
                        >
                          <div>
                            <h4 class="name">Specimen Types</h4>
                            <ul
                              class="case_type"
                              v-if="
                                getSinglePhlebioDetails.sample_types &&
                                getSinglePhlebioDetails.sample_types.length
                              "
                            >
                              <li
                                class="value"
                                v-for="(
                                  sampleType, index
                                ) in getSinglePhlebioDetails.sample_types"
                                :key="index"
                              >
                                {{ caseTypeMap[sampleType.case_type] }}
                              </li>
                            </ul>
                            <ul v-else>
                              --
                            </ul>
                          </div>
                          <div>
                            <h4 class="name">&nbsp;</h4>

                            <ul
                              class="speciment_type"
                              v-if="
                                getSinglePhlebioDetails.sample_types &&
                                getSinglePhlebioDetails.sample_types.length
                              "
                            >
                              <li
                                v-for="(
                                  sampleType, index
                                ) in getSinglePhlebioDetails.sample_types"
                                :key="index"
                              >
                                <span
                                  v-if="
                                    sampleType.sample_types &&
                                    sampleType.sample_types.length
                                  "
                                >
                                  <span
                                    v-for="(
                                      sample, index
                                    ) in sampleType.sample_types"
                                    :key="index"
                                  >
                                    {{ sample }}
                                    <span
                                      v-if="
                                        index + 1 <
                                        sampleType.sample_types.length
                                      "
                                      >,</span
                                    >
                                  </span>
                                </span>
                                <span v-else> -- </span>
                              </li>
                            </ul>
                            <ul v-else>
                              --
                            </ul>
                          </div>
                        </div>
                      </div>
                    </el-col>
                    <el-col :xl="10" :lg="10" :md="10" :sm="10" :xs="10">
                      <div class="input-value">
                        <h4 class="name">Order Codes</h4>
                        <ul
                          class="order_code"
                          v-if="
                            getSinglePhlebioDetails &&
                            getSinglePhlebioDetails.Lab_tests_collected
                          "
                        >
                          <li
                            class="totalList"
                            v-if="
                              Array.isArray(
                                getSinglePhlebioDetails.Lab_tests_collected
                              )
                            "
                          >
                            <div
                              class="eachList radius-10"
                              v-for="order in getSinglePhlebioDetails.Lab_tests_collected"
                              :key="order"
                            >
                              {{ order }}
                            </div>
                          </li>
                        </ul>
                      </div>
                    </el-col>
                    <el-col :xl="12" :lg="12" :md="12" :sm="12" :xs="12">
                      <div class="input-value">
                        <h4 class="name">Lab Tests Collected</h4>

                        <ul class="order_code">
                          <li class="totalList">
                            <p class="eachList radius-10">
                              {{
                                getSinglePhlebioDetails.Labtests_collected
                                  ? getSinglePhlebioDetails.Labtests_collected
                                  : "--"
                              }}
                            </p>
                          </li>
                        </ul>
                      </div>
                    </el-col>
                  </el-row>
                </div>
                <span class="case-creation__divider"></span>
                <div
                  class="phlebio-order mb-15"
                  v-if="
                    getSinglePhlebioDetails &&
                    getSinglePhlebioDetails.tests_info &&
                    getSinglePhlebioDetails.tests_info.length > 0
                  "
                >
                  <TestInformation></TestInformation>
                </div>

                <div
                  class="case-creation__card mb-15"
                  v-if="
                    getSinglePhlebioDetails &&
                    getSinglePhlebioDetails.Phlebio_Order_Status_History &&
                    getSinglePhlebioDetails.Phlebio_Order_Status_History
                      .length > 0
                  "
                >
                  <div class="case-creation__heading edit-view">
                    <div class="title-with-icon">
                      <span class="icon">
                        <img
                          src="@/assets/images/icons/icon-patient-info.svg"
                          alt="icon"
                          class="img-fluid"
                        />
                      </span>
                      <h3 class="title">PHLEBIO ORDER STATUS HISTORY</h3>
                    </div>
                  </div>
                  <div>
                    <div class="history-table w-100" style="padding: 0!important;">
                      <div
                        class="listings listings__table listings__all-cases"
                        id="all-cases-listings"
                      >
                        <el-table
                          :data="
                            getSinglePhlebioDetails.Phlebio_Order_Status_History
                          "
                        >
                          <el-table-column
                            label="Phlebio Order Id"
                            prop="Phlebio_Order_id"
                          >
                            <template #default="scope">
                              <span>
                                {{
                                  scope.row.Phlebio_Order_id
                                    ? scope.row.Phlebio_Order_id
                                    : "--"
                                }}
                              </span>
                            </template>
                          </el-table-column>
                          <el-table-column
                            label="Technician Name"
                            prop="Technician"
                          >
                            <template #default="scope">
                              <span>
                                {{
                                  scope.row.Technician
                                    ? scope.row.Technician
                                    : "--"
                                }}
                              </span>
                            </template>
                          </el-table-column>
                          <el-table-column label="Status" prop="Status">
                            <template #default="scope">
                              <span>
                                {{ scope.row.Status ? scope.row.Status : "--" }}
                              </span>
                            </template>
                          </el-table-column>
                          <el-table-column label="Notes" prop="Notes">
                            <template #default="scope">
                              <span>
                                {{ scope.row.Notes ? scope.row.Notes : "--" }}
                              </span>
                            </template>
                          </el-table-column>
                          <el-table-column label="Date & Time" prop="Date/Time">
                            <template #default="scope">
                              <span>
                                {{
                                  scope.row["Date/Time"]
                                    ? convertToUTC(scope.row["Date/Time"])
                                    : "--"
                                }}
                              </span>
                            </template>
                          </el-table-column>
                        </el-table>
                      </div>
                    </div>
                  </div>
                </div>
                <div v-if="hasBillingType">
                  <BillingInformation></BillingInformation>
                </div>
                <span class="case-creation__divider"></span>
                <Medication></Medication>
                <div
                  v-if="
                    getSinglePhlebioDetails &&
                    getSinglePhlebioDetails.attachments &&
                    getSinglePhlebioDetails.attachments.length > 0
                  "
                >
                  <Attachments></Attachments>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import { defineAsyncComponent } from "vue";

import { mapGetters } from "vuex";
import AppHelper from "@/mixins/AppHelper";
import caseDataHelper from "@/mixins/caseDataHelper";
import UserPermissionsHelper from "@/mixins/UserPermissionsHelper";
import HospitalHelper from "@/mixins/HospitalHelper";

import caseConstants from "@/config/constants/caseConstants";
const BillingInformation = defineAsyncComponent(() =>
  import("@/components/phlebioOrders/BillingInformations")
);
import moment from "moment";
const Medication = defineAsyncComponent(() =>
  import("@/components/phlebioOrders/MedicationView")
);
const TestInformation = defineAsyncComponent(() =>
  import("@/components/phlebioOrders/ViewTests")
);
const Attachments = defineAsyncComponent(() =>
  import("@/components/phlebioOrders/Attachments")
);
export default {
  components: {
    BillingInformation,
    Medication,
    TestInformation,
    Attachments,
  },
  mixins: [AppHelper, UserPermissionsHelper, HospitalHelper, caseDataHelper],
  async created() {
    this.orderId = this.$route.params.phlebio_id;
    if (this.$route.params.phlebio_id) {
      await this.caseDetailsView();
    }
  },
  watch: {},
  computed: {
    ...mapGetters("phlebio", [
      "getSinglePhlebioDetails",
      "getValidationErrors",
    ]),

    ...mapGetters("auth", ["getAuthenticatedUser"]),
    ...mapGetters("hospitals", ["getAllHospitals"]),
    ...mapGetters("physicians", ["getAllPhysicians"]),
    ...mapGetters("branches", ["getAllBranches"]),
    ...mapGetters("icd10Codes", ["getAllIcd10Codes"]),
    ...mapGetters("labs", ["getAllLabs"]),
    getPatientInformation() {
      if (
        this.getSinglePhlebioDetails &&
        Object.keys(this.getSinglePhlebioDetails).length > 0 &&
        this.getSinglePhlebioDetails
      ) {
        return this.getSinglePhlebioDetails;
      }
      return null;
    },
    canShowEditButton() {
      const order = this.getSinglePhlebioDetails;

      if (!order) return false;

      // Check for valid statuses
      const validStatuses = [
        "Completed",
        "Performed",
        "Delivered to Lab",
        "Accession created",
        "Deliverd to Lab",
        "Partial Accession"
      ];

      // Check if status is valid
      const isStatusValid = validStatuses.includes(order.Status);

      // Check if accession_id exists
      const isAccessionCreated = !!order.accession_id;

      // Check if accession_data and case_types lengths are the same
      const isLengthsEqual =
        order.accession_data?.length === order.case_types?.length;

      return isStatusValid && !isAccessionCreated && !isLengthsEqual;
    },

    accessionCreated() {
      const order = this.getSinglePhlebioDetails;
      if (order && order.accession_id) {
        return false;
      }
      if (
        order &&
        order.accession_data &&
        order.case_types &&
        order.accession_data.length === order.case_types.length
      ) {
        return false;
      }
      return true;
    },
    accessionDisableCreated() {
      const order = this.getSinglePhlebioDetails;
      if (order && order.accession_id) {
        return true;
      }
      if (
        order &&
        order.accession_data &&
        order.accession_data.length > 0 &&
        order.case_types &&
        order.case_types.length > 0 &&
        order.accession_data.length === order.case_types.length
      ) {
        return true;
      }
      if (order && order.accession_data && order.accession_data.length == 0) {
        return false;
      }
      if (order && order.case_types && order.case_types.length == 0) {
        return false;
      }
      return false;
    },

    editButtonTitle() {
      if (this.accessionDisableCreated) {
        return "Can't edit accession created";
      }

      return "";
    },

    ...mapGetters("errors", ["getErrors", "getError"]),

    hasBillingType() {
      if (
        this.getSinglePhlebioDetails &&
        this.getSinglePhlebioDetails.billing_type &&
        this.getSinglePhlebioDetails.billing_type == "INSURANCE"
      ) {
        return true;
      }
      return false;
    },
    checkEMROrNot() {
      let patientInfo = this.getPatientInformation;
      
      if (
        (patientInfo && patientInfo.Emr_order_id) ||
        (patientInfo && patientInfo.patient_info && patientInfo.patient_info.emr)
      ) {
        return true;
      } else {
        return false;
      }
    }
  },

  data() {
    return {
      caseTypeMap: caseConstants.CASE_TYPE_MAP,

      orderId: "",
      loading: false,

      patientInformation: {},
    };
  },

  methods: {
    printICDCode(icd_code) {
      let formatted_icd_code = "";
      for (let i = 0; i < icd_code.length; i++) {
        formatted_icd_code += "<span> " + icd_code[i] + "</span>";
      }
      return formatted_icd_code;
    },
    convertToUTC(dateStr) {
      return dateStr.replace(/\//g, '-');
    },
    goToCaseView(case_id) {
      this.$router.push({
        name: "CaseView",
        params: { case_id: case_id },
        query: { ...this.$route.query, redirectRoute: this.$route.name },
      });
    },

    caseDetailsView() {
      this.checkCaseInformation();
    },

    async caseFormView() {
      this.$router.push({
        name: "EditPhlebioOrderDetails",
        params: { phlebio_id: this.orderId },
        query: this.$route.query,
      });
    },

    async askReason() {
      this.takeReasonDialog = true;
    },

    async checkCaseInformation() {
      this.loading = true;

      let params = {
        phlebio_id: this.$route.params.phlebio_id,
      };
      await this.$store.dispatch("phlebio/phlebioDetails", params);
      if (
        this.getSinglePhlebioDetails &&
        this.getSinglePhlebioDetails.patient_info
      ) {
        this.patientInformation = this.getSinglePhlebioDetails.patient_info;
      }
      this.loading = false;
    },
  },
};
</script>

<style lang="scss">
#view-emr-order {
  padding: 0;
  .phlebio-status-navbar {
    border-top: 1.2px solid #e7e7f7;
    border-bottom: 1.2px solid #e7e7f7;
    font-size: 14px;
    background: #ffffff;
    border-radius: 7px;
    padding: 3px 10px;
    margin-bottom: 10px;
    @mixin button-style {
      padding: 0 10px;
      font-size: 14px;
      border-radius: 4px;
      font-weight: 500;
      height: 25px;
      min-height: auto;
      text-transform: uppercase;
      display: inline-flex;
      align-items: center;
      justify-content: center;
    }
    .name {
      color: rgba(37, 33, 59, 0.8);
      text-transform: capitalize;
      margin-right: 10px;
      font-weight: 500;
    }
    .value {
      border: 0.6px solid #5162fd;
      color: #5162fd;
      margin-right: 10px;
      @include button-style();
      margin-right: 7px;
      font-size: 12.5px;

      &.COMPLETED {
        background: #f2f2f2;
        border: 0.6px solid #4bb543;
        color: #4bb543;
      }
      &.CANCELLED {
        background: #f2f2f2;
        border: 0.6px solid #eb5757;
        color: #eb5757;
      }
    }
    .emr-result {
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      li {
        margin: 5px 0;
        &:not(:last-child) {
          margin-right: 10px;
        }
      }
    }
    .emr-order-status {
      display: flex;
      align-items: center;
      justify-content: flex-end;
      flex-wrap: wrap;
      li {
        margin: 5px 0;
        &:not(:last-child) {
          margin-right: 10px;
        }
        button {
          @include button-style();
        }
        .text-danger {
          @include button-style();
          background-color: #fe7968;
          border: none;
        }
      }
    }
  }
  .phlebio-order {
    .case-creation__card {
      background: #ffffff !important;
    }
  }
  .tabs-content {
    .case-creation__card {
      background: transparent;
      position: relative;
      border: none;
    }

    .case-creation__heading,
    .case-creation__body {
      background: #fff;
      border-radius: 6.40567px;
    }

    .title-block {
      display: none;
    }
    .steps-data-view {
      background: #fff;
      padding: 20px;
      .title-with-icon {
        margin-bottom: 5px;
        .title {
          font-size: 1.1em;
          color: #0a5da6;
        }
      }
    }
  }

  .case-creation__body {
    position: relative;
  }
  .case-creation__billing-information__body {
    background: #fff;
  }
  .edit-btn {
    position: absolute;
    right: 10px;
    border: none;
    z-index: 99;
    right: 15px;
    padding: 0;
    top: -3px;

    background-color: transparent;
    color: #828282;
    .edit-icon {
      img {
        position: relative;
        top: 2.5px;
      }
    }
  }
}
</style>
